import {useNavigate} from 'react-router-dom';
import CustomHeader from '../../../../components/mazraeKit/headers/homeHeader';
import PendingHourGlass from './components/PendingHourGlass';

const PendingInstallmentCardToCardPage = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col w-full bg-white h-dvh">
      <CustomHeader
        preComponent={() => (
          <div
            className="relative flex items-center gap-2"
            onClick={() => navigate('/home')}
          >
            <i className="icon-nameArrow---Right text-[25px] text-gray-700" />
            <span className="font-medium">پرداخت</span>
          </div>
        )}
      />

      <div className="flex flex-col w-full h-full gap-3 p-6 overflow-y-auto">
        <span className="mb-2 text-sm text-gray-600">
          تصویر فیش پرداخت شما بارگذاری شد و توسط کارشناسان ما در حال بررسی است.
          نتیجه از طریق پیامک اطلاع داده می‌شود.
        </span>
        <PendingHourGlass />
      </div>
    </div>
  );
};

export default PendingInstallmentCardToCardPage;
